import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoginForm from '../../components/forms/LoginForms';

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();
  
  const handleSubmit = async (credentials) => {
    setIsLoading(true);
    
    try {
      // Login sempre será bem-sucedido em modo de demonstração
      await login(credentials);
      // Redirecionar para dashboard após login bem-sucedido
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      // Em caso de falha, apenas mostrar no console, mas nunca deve acontecer
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="flex h-screen w-full bg-gray-50">
      {/* Left Panel - Property Image and Info */}
      <div className="hidden md:flex w-1/2 bg-blue-900 text-white relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-900/60"></div>
        
        <div className="relative z-10 p-12 flex flex-col h-full">
          <div className="mb-12">
            <div className="bg-white text-blue-900 font-bold text-xl py-4 px-8 rounded-md inline-block">
              SURFLAND BRASIL
            </div>
          </div>
          
          <div className="mt-auto mb-24">
            <h1 className="text-4xl font-bold mb-4">Resort Surfland Brasil</h1>
            <p className="text-xl mb-2">Seu destino em multipropriedade</p>
            
            <ul className="space-y-4">
              <li className="flex items-center">
                <div className="w-4 h-4 rounded-full bg-white mr-4"></div>
                <span>Infraestrutura completa de lazer</span>
              </li>
              <li className="flex items-center">
                <div className="w-4 h-4 rounded-full bg-white mr-4"></div>
                <span>Administração profissional</span>
              </li>
            </ul>
          </div>
          
          <div className="text-sm opacity-70">
            Foto: Vista aérea do Resort Surfland Brasil
          </div>
        </div>
      </div>
      
      {/* Right Panel - Login Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Formulário de login */}
          <LoginForm onSubmit={handleSubmit} isLoading={isLoading} />
          
          {/* Footer */}
          <div className="text-center mt-8">
            <p className="text-xs text-gray-500">
              Copyright © 2025 Resort Surfland Brasil. Todos os direitos reservados.
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Suporte: suporte@surflandbrasil.com | (71) 3333-4444
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;   